import { Box } from "@bca/ui-library";
import React, { useContext } from "react";
import { ThemeContext } from "styled-components";

import StyledIcon from "../Interfaces/StyledIcon";

const LotNotFoundSVG: React.FunctionComponent<StyledIcon> = ({
  fill = "grey-blue",
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const hexColor = theme.colors[fill] || fill;
  return (
    <Box
      display="inline-block"
      data-testid="lot-not-found-container"
      {...props}
    >
      <svg
        aria-hidden="true"
        data-testid="lot-not-found-svg"
        focusable="false"
        height="100%"
        role="img"
        fill="none"
        viewBox="0 0 56 42"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={hexColor}
          fillRule="evenodd"
          d="M32.557 3.552c-.716-.141-1.455-.214-2.207-.214h-12.7c-4.606 0-8.688 2.752-10.399 7.012l-1.993 4.964-1.124 2.799C1.722 19.026 0 21.333 0 24.056v4.782c0 1.605.616 3.055 1.6 4.176V38.4c0 1.76 1.433 3.188 3.2 3.188H8c1.767 0 3.2-1.428 3.2-3.188v-3.187h25.6V38.4c0 1.76 1.433 3.188 3.2 3.188h3.2c1.767 0 3.2-1.428 3.2-3.188v-5.386c.984-1.12 1.6-2.57 1.6-4.176v-4.782c0-1.806-.758-3.43-1.972-4.584-.965.263-1.98.403-3.028.403-2.525 0-4.86-.814-6.757-2.194H11.2l1.993-4.963c.729-1.815 2.494-3.005 4.457-3.005h12.7c.428 0 .847.056 1.247.164-.064-.492-.097-.993-.097-1.502 0-1.722.379-3.356 1.057-4.823zM4.8 25.64c0 1.907 1.28 3.178 3.2 3.178.233 0 .48.004.734.01 1.842.034 4.066.076 4.066-1.599 0-1.907-2.88-4.766-4.8-4.766s-3.2 1.27-3.2 3.177zm34.466 3.187c.254-.005.501-.01.734-.01 1.92 0 3.2-1.27 3.2-3.177 0-1.906-1.28-3.177-3.2-3.177-1.92 0-4.8 2.86-4.8 4.766 0 1.675 2.224 1.633 4.066 1.598z"
          clipRule="evenodd"
        ></path>
        <path
          fill={hexColor}
          d="M55.213 18.17l-4.102-4.102c-.205-.164-.45-.287-.697-.287h-.656c1.107-1.435 1.804-3.24 1.804-5.25 0-4.676-3.855-8.531-8.53-8.531C38.314 0 34.5 3.855 34.5 8.531c0 4.717 3.815 8.531 8.531 8.531 1.969 0 3.774-.656 5.25-1.804v.697c0 .246.082.492.287.697l4.06 4.06c.411.411 1.026.411 1.395 0l1.149-1.148c.41-.369.41-.984.04-1.394zM43.03 13.78c-2.912 0-5.25-2.338-5.25-5.25 0-2.87 2.338-5.25 5.25-5.25 2.871 0 5.25 2.38 5.25 5.25 0 2.912-2.379 5.25-5.25 5.25z"
        ></path>
      </svg>
    </Box>
  );
};

export default LotNotFoundSVG;
